export const COMPLETION = {
    NEXT: 'next',
    PREVIOUS: 'previous',
    TIMEOUT: 'timeout',
    EVENT: 'event',
    NAVIGATION: 'navigation',
    MOUNTED: 'mounted',
    LOADED: 'loaded',
    COMMAND: 'command',
    RENDER: 'render',
    DECISION_TRUE: 'decision-true',
    DECISION_FALSE: 'decision-false',
} as const;

export const KICK = {
    TIMEOUT: 'timeout',
    EVENT: 'event',
    COMMAND: 'command',
    SYSTEM_COMMAND: 'system_command',
} as const;

export const EVENT_VALUES = {
    PRESENT: 'present',
    NOT_PRESENT: 'not_present',
    VISIBLE: 'visible',
    NOT_VISIBLE: 'not_visible',
    CLICK: 'dom_click',
    SPOT_VIEWPORT: 'spot_viewport',
    MOUSE_UP: 'mouseup',
    MOUSE_DOWN: 'mousedown',
    MOUSE_OVER: 'mouseenter',
    MOUSE_LEAVE: 'mouseleave',
    CHANGE: 'change',
    LEAVE_ATTENTION: 'leave_attention',
    TIMEOUT: 'timeout',
    COMMAND: 'command',
    BLUR: 'blur',
    FOCUS: 'focus',
    FOCUS_OUT: 'focusout',
} as const;

export const EVENT_TARGET = {
    ELEMENT: 'ELEMENT',
    WINDOW: 'WINDOW',
    DOCUMENT: 'DOCUMENT',
    NONE: 'NONE',
} as const;

export const EVENT_OPERAND = {
    AND: 'and',
    OR: 'or',
    EVENT: 'event',
} as const;

export const ASPECT = {
    RESET: 'reset',
    CLOSE: 'close',
    JUMP_TO: 'jump_to',
    SUSPEND: 'suspend',
    RESUME: 'resume',
} as const;

export const ELEMENT_PATH_SEARCH_STRATEGY = {
    EXACT_ROOT_MATCH: 'exactRootMatch',
    BEST_DERIVED_CARDINALITY_MATCH: 'bestDerivedCardinalityMatch',
    FEATURES_ENRICHED_BEST_DERIVED_CARDINALITY_MATCH: 'featuresEnrichedBestDerivedCardinalityMatch',
    JS_PATH_QUERY: 'exactJsPathQuery'
} as const;

export const ELEMENT_PATHS = {
    RELATIVE: 'relative',
    RELATIVE_LIMITED: 'relativeLimited',
    EXPRESSED: 'expressed',
    CLASS_ONLY: 'classOnly',
    XPATH: 'xpath',
    XPATH_LIMITED: 'xpathLimited',
    TAG_ONLY: 'tagOnly',
    JS_PATH: 'jsPath',
    JS_PATH_NON_RELATIVE: 'jsPathNonRelative',

} as const;

export const EXCLUDED_LOCATION_PREFIX = 'excluded-location-';

export const NO_PATH = 'NO_PATH';

export const NO_PATTERN = 'NO_PATTERN';

export const NO_URL = 'NO_URL';

export const ELEMENT_PATH_ORDER = [
    ELEMENT_PATHS.XPATH,
    ELEMENT_PATHS.RELATIVE,
    ELEMENT_PATHS.XPATH_LIMITED,
    ELEMENT_PATHS.RELATIVE_LIMITED,
    ELEMENT_PATHS.EXPRESSED,
    ELEMENT_PATHS.CLASS_ONLY,
    ELEMENT_PATHS.TAG_ONLY,
    ELEMENT_PATHS.JS_PATH,
    ELEMENT_PATHS.JS_PATH_NON_RELATIVE,
] as const;

export const COLLECTOR_EVENT_TYPE = {
    CLICK: 'click',
    MOUSE_ENTER: 'mouse-enter',
    CHANGE: 'change',
    SPOT: 'spot',
    UNSPOT: 'unspot',
    SPOT_VIEWPORT: 'spot-in-viewport',
} as const;

export const DECISION_ELEMENT_CONDITION_TYPE = {
    ELEMENT_PRESENT: 'elementPresent',
    ELEMENT_VISIBLE: 'elementVisible',
} as const;
